module.exports = __webpack_public_path__ + "img/default-file-icon.eddab881.svg";